






















import { defineComponent } from '@vue/composition-api';

import Tooltip from '@/components/atoms/Tooltip.vue';

import { useAdvisorSearchUserTopicBookmark } from '@/modules/advisor-search/organisms/AdvisorSearchUser/AdvisorSearchUserTopicBookmark';

export default defineComponent({
  name: 'AdvisorSearchUserTopicBookmark',
  components: {
    Tooltip,
  },
  props: {
    topicId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const { state, bookmarkStatus, toggle } = useAdvisorSearchUserTopicBookmark(
      props,
      false,
    );
    return {
      state,
      bookmarkStatus,
      toggle,
    };
  },
});
